import React from 'react';
import { NAV_TARGETS, openInApp } from '../services/openInMaps';

interface NavigateSheetProps {
  visible: boolean;
  lat: number;
  lng: number;
  label?: string;
  onClose: () => void;
}

/**
 * Bottom sheet on mobile, centered modal on desktop. Lists the navigation apps.
 */
export const NavigateSheet: React.FC<NavigateSheetProps> = ({
  visible,
  lat,
  lng,
  label,
  onClose,
}) => {
  if (!visible) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-end md:items-center justify-center bg-black/40"
      onClick={onClose}
    >
      <div
        className="bg-card w-full md:max-w-sm rounded-t-xl md:rounded-lg p-s5 pb-s7 md:pb-s5 border border-rule"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="caption text-ink3 mb-s3">Open in</div>
        <div className="flex flex-col gap-s2">
          {NAV_TARGETS.map((target) => (
            <button
              key={target.id}
              onClick={() => {
                openInApp(target, lat, lng, label);
                onClose();
              }}
              className="w-full text-left px-s4 py-s3 border border-rule rounded-lg font-sans text-[14px] text-ink1 bg-card hover:bg-tint transition-colors"
            >
              {target.name}
            </button>
          ))}
        </div>
        <button
          onClick={onClose}
          className="w-full mt-s4 py-s3 text-[12px] text-ink3 font-sans"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};
